import { operatorColors } from '~/utils/operatorColors';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de potenciação (a^b)
export const OperatorPowerNode = ({ data, notNode = false, onDataChange }) => {
    const isVertical = (data?.layout || 'vertical') === 'vertical';
    // Função para lidar com a mudança dos drops de entrada
    const handleBaseChange = (newDrop) => onDataChange({ baseDrop: newDrop, exponentDrop: data.exponentDrop });
    const handleExponentChange = (newDrop) => onDataChange({ baseDrop: data.baseDrop, exponentDrop: newDrop });
    
    return (
        <div className="node-operator-power" style={{ 
            display: 'flex', 
            flexDirection: isVertical ? 'column' : 'row',
            alignItems: isVertical ? 'center' : 'flex-end', 
            justifyContent: 'center',
            gap: '4px',
            width: '100%',
            position: 'relative'
        }}>
            {/* Base (número principal) */}
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <CustomInputDrop 
                    dropData={data.baseDrop || { id: 'base', type: null, data: {} }} 
                    dropId="base" 
                    onDropChange={handleBaseChange} 
                    style={{ fontSize: '16px' }}
                />
            </div>
            
            {/* Expoente (número pequeno em cima) */}
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'flex-start',
                position: 'relative'
            }}>
                <div style={{ 
                    marginBottom: '8px', 
                    transform: 'scale(0.75)', 
                    transformOrigin: 'left bottom',
                    position: 'relative',
                    top: '-8px'
                }}>
                    <CustomInputDrop 
                        dropData={data.exponentDrop || { id: 'exponent', type: null, data: {} }} 
                        dropId="exponent" 
                        onDropChange={handleExponentChange} 
                        style={{ fontSize: '12px' }}
                    />
                </div>
                
                {/* Símbolo de potência */}
                <div style={{
                    background: operatorColors['Potenciação'] || '#e83e8c',
                    color: 'white',
                    borderRadius: '6px',
                    padding: '4px 8px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    minWidth: '30px',
                    textAlign: 'center',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '-4px'
                }}>
                    ^
                </div>
            </div>
            
            {!notNode && <CustomHandle type="target" position="top" connectionCount={1} />}
            {!notNode && <CustomHandle type="source" position="bottom" connectionCount={1} />}
        </div>
    );
};
